import { Service } from './types';

export const SERVICES: Service[] = [
  {
    id: 'marketing',
    title: 'حلول التسويق والوساطة',
    description: 'نمتلك شبكة واسعة من المستثمرين ونستخدم أدوات تحليلية دقيقة لضمان وصول عقارك للفئة المثالية وتحقيق أفضل قيمة سوقية ممكنة.',
    icon: 'plus'
  },
  {
    id: 'management',
    title: 'إدارة وتطوير الأصول',
    description: 'تولي شركتنا مسؤولية التشغيل الكامل لعقاراتكم، من صيانة وتحصيل وعلاقات مستأجرين، لنضمن لكم دخلاً مستداماً ونمواً في قيمة الأصل.',
    icon: 'plus'
  },
  {
    id: 'e-sales',
    title: 'الاستثمار العقاري الذكي',
    description: 'نقدم استشارات مبنية على بيانات السوق الواقعية لمساعدتكم في اتخاذ قرارات الشراء والبيع الأكثر ربحية في القطاع السكني والتجاري.',
    icon: 'plus'
  }
];
